import customList from './customList'
import agCustomList from './agCustomList'
import remindList from './remindList'
import followCustomList from './followCustomList'
import note from './note'
import email from './email'
export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...customList,
      ...agCustomList,
      ...remindList,
      ...followCustomList,
      ...note,
      ...email,
      {
        path: '/channel_communication',
        name: 'ChannelList',
        component: () => import('@/pages/ChannelCommunication/index.vue'),
        meta: { name: '渠道沟通情况' }
      },
      {
        path: '/analyze_list',
        name: 'EnterpriseAnalyzeList',
        component: () => import('@/pages/EnterpriseAnalyzeList/index.vue'),
        meta: { name: '用户分析', keepAlive: true }
      },
      {
        path: '/analyze_list/FollowDetail/:orderId',
        name: 'AnalyzeList_FollowDetail',
        component: () => import('@/pages/customManage/followCustomList/cusFollowDetail/FollowDetail'),
        props: true,
        meta: { name: ['用户分析', '客户详情'] }
      },
      {
        path: '/analyze_list/FollowDetail_two/:orderId',
        name: 'AnalyzeList_FollowDetail_two',
        component: () => import('@/pages/customManage/followCustomList/cusFollowDetail/FollowDetail'),
        props: true,
        meta: { name: ['用户分析', '客户详情'] }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/customManage/index.js